export default __webpack_public_path__ + "static/RootSans-2ThinItalic-1d530c6540f56494dbea9447df10a641.woff";